import React from 'react';
import '../styles/global.css'; // Seu CSS global

function Admin() {
  return (
    <div className="App">
      <main>
        <div className='headerMain'>
        <label className='labelTitulo' >ADMINISTRAÇÃO DO SITE</label>
        <h1>Admin</h1>
        </div>
      </main>
    </div>
  );
}

export default Admin;